import { render } from "./NavigationContent.vue?vue&type=template&id=781428b6"
import script from "./NavigationContent.vue?vue&type=script&lang=js"
export * from "./NavigationContent.vue?vue&type=script&lang=js"

import "./NavigationContent.vue?vue&type=style&index=0&id=781428b6&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__